import React from 'react';
import { Box, Paper, Typography, Divider, Grid, Avatar } from '@mui/material';

const AverageGradeCard = ({ listData = [] }) => {
  const calculateMetrics = (data) => {
    const filteredData = data.filter((item) => item.rating !== 'To be done' && item.rating !== 'Total');

    let totalScore = 0;
    let totalCount = 0;

    filteredData.forEach((item) => {
      totalScore += item.count;
      totalCount += item.count;
    });

    const avg = totalCount > 0 ? totalScore / filteredData.length : 0;
    const objective = Math.ceil(avg * 100) / 100 + 0.01;

    let grade = 'E';
    if (avg <= 0.7) grade = 'S';
    else if (avg <= 0.95) grade = 'A';
    else if (avg <= 1.25) grade = 'B';
    else if (avg <= 1.75) grade = 'C';
    else grade = 'D';

    return {
      averageGrade: grade,
      averageRating: avg.toFixed(3),
      objectiveRating: objective.toFixed(2).replace('.', ','),
    };
  };

  const { averageGrade, averageRating, objectiveRating } = calculateMetrics(listData);

  return (
    <Paper elevation={6} sx={{ p: 3, borderRadius: 4, height: '100%', overflow: 'hidden', bgcolor: '#f9fafb' }}>
      <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
        <Avatar
          sx={{
            bgcolor: '#1976d2',
            width: 72,
            height: 72,
            mb: 1,
            fontSize: 40,
            fontWeight: 'bold',
          }}
        >
          {averageGrade}
        </Avatar>
        <Typography variant="subtitle1" color="text.secondary">
          Average grade
        </Typography>
      </Box>

      <Divider sx={{ my: 2, mt: 3 }} />

      <Grid container spacing={2} justifyContent="center" sx={{ mt: 1 }}>
        <Grid item xs={6} textAlign="center">
          <Typography variant="h6" color="primary">
            {averageRating}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Average rating
          </Typography>
        </Grid>
        <Grid item xs={6} textAlign="center">
          <Typography variant="h6" color="primary">
            {objectiveRating}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Objective rating
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AverageGradeCard;
